import React from "react";
import { Redirect } from "react-router-dom";

// Layout Types
import { DefaultLayout } from "./layouts";

// Route Views
import CovidOverView from "./views/CovidOverview";
import Developer from "./views/Developer";
import AddNewPost from "./views/AddNewPost";
import PMCaresFund from "./views/PMCaresFund";
import CountryWise from "./views/CountryWise";
import CovidNews from "./views/CovidNews";
import StateWiseCoronaCases from "./views/StateWiseCoronaCases";

export default [
  {
    path: "/",
    exact: true,
    layout: DefaultLayout,
    component: () => <Redirect to="/covid-overview" />
  },
  {
    path: "/covid-overview",
    layout: DefaultLayout,
    component: CovidOverView
  },
  {
    path: "/developer",
    layout: DefaultLayout,
    component: Developer
  },
  {
    path: "/state-wise",
    layout: DefaultLayout,
    component: StateWiseCoronaCases
  },
  {
    path: "/pm-cares-fund",
    layout: DefaultLayout,
    component: PMCaresFund
  },
  {
    path: "/country-wise",
    layout: DefaultLayout,
    component: CountryWise
  },
  {
    path: "/symptoms",
    layout: DefaultLayout,
    component: AddNewPost
  },
  {
    path: "/news",
    layout: DefaultLayout,
    component: CovidNews
  }
];
